function Part4() {
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <div className="about" style={{ marginTop: "10px", textAlign: "center" }}>
          <h1>About Us</h1>
          <p>The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections
            1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact
            original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
        </div>
      </div>
    </div>
  )
}


export default Part4